<dl class="iackathon-step-canvas__description-list">

    @for (entry of canvasEntries(); track entry.id) {
        <div class="iackathon-step-canvas__description-container">
            <dt class="iackathon-step-canvas__description-term">
                {{ entry.labelKey | translate }}
            </dt>
            <dd class="iackathon-step-canvas__description-value"
                [class.iackathon-step-canvas__description-value--no-data]="!entry.value"]>
                {{ entry.value || ('iackathon.data_not_provided' | translate) }}
            </dd>
        </div>
    }

</dl>
